import { requestAxios } from 'services';
import { historyGetFactory } from 'factories';
import { History } from 'types';

interface GetProps {
  consignmentCode: string;
  storeNames: string[];
}

async function get({
  consignmentCode,
  storeNames,
}: GetProps): Promise<History> {
  let result: any;
  const params = {
    code: consignmentCode,
    storeNames: storeNames.join(','),
  };

  try {
    const response = await requestAxios.get('history', { params });

    result = response.data;
  } catch (error) {
    console.error(error);
  }

  return historyGetFactory(result);
}

interface PostProps {
  type: string;
  consignmentCode: string;
  store: string;
}

async function post({ type, consignmentCode, store }: PostProps): Promise<any> {
  let result: any;
  const params = {
    type,
    store,
    code: consignmentCode,
  };
  const body = {
    observation: undefined,
  };

  try {
    const response = await requestAxios.post('history', body, { params });

    result = response;
  } catch (error) {
    console.error(error);
  }

  return result;
}

export const historyService = {
  get,
  post,
};
